import {BulkTranslation} from 'bulk-workflows/translation/BulkTranslationConstants';
import * as TaskRunner from 'util/TaskRunner';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function run(bulkTranslation: BulkTranslation): JQueryPromise<any> {
  // Prepare for server
  const bulkTranslationJSON = {
    sequenceIds: bulkTranslation.sequences.map((sequence) => sequence.id),
    // TODO(T8838): Always create a new folder
    folderId: bulkTranslation.outputFolderId,
    translationSpecs: bulkTranslation.translationSpecs
      .filter((translationSpec) => translationSpec.firstCodonAnnotationName.length > 0)
      .map((translationSpec) => ({
        tagSchemaFieldId: translationSpec.tagSchemaField.id,
        firstCodonAnnotationName: translationSpec.firstCodonAnnotationName,
        firstCodonOffset: translationSpec.firstCodonOffset,
      })),
  };
  return TaskRunner.runTask({
    contentType: 'application/json',
    data: JSON.stringify(bulkTranslationJSON),
    dataType: 'json',
    type: 'POST',
    url: '/1/api/bulk-workflows/translation/run',
  });
}
